(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-carousel]').forEach((root) => {
      const track = root.querySelector('[data-product-track]');
      if (!track) return;
      let interval = null;
      let initial = null;
      let resume = null;
      const clearAuto = () => { clearTimeout(initial); clearInterval(interval); initial = null; interval = null; };
      const start = () => {
        clearAuto();
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        initial = setTimeout(() => {
          interval = setInterval(() => {
            const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
            track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + 240, behavior: 'smooth' });
          }, 3000);
        }, 4000);
      };
      const interact = (direction) => {
        clearAuto();
        clearTimeout(resume);
        track.scrollBy({ left: direction * 240, behavior: 'smooth' });
        resume = setTimeout(start, 5000);
      };
      root.querySelector('[data-product-prev]')?.addEventListener('click', () => interact(-1));
      root.querySelector('[data-product-next]')?.addEventListener('click', () => interact(1));
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    const search = document.querySelector('[data-search-overlay]');
    if (menu) document.body.appendChild(menu);
    if (search) document.body.appendChild(search);
    let searchOpener = null;
    const positionMenu = () => {
      if (!menu) return;
      const headerBottom = Math.max(0, document.querySelector('.yoria-header')?.getBoundingClientRect().bottom || 64);
      menu.style.top = `${headerBottom}px`;
      menu.style.height = `calc(100dvh - ${headerBottom}px)`;
    };
    const syncScrollLock = () => { document.body.style.overflow = (menu && !menu.hidden) || (search && !search.hidden) ? 'hidden' : ''; };
    const focusFirst = (container) => { container?.querySelector('input,button,a,select,[tabindex]:not([tabindex="-1"])')?.focus(); };
    const trapFocus = (event, container) => {
      if (event.key !== 'Tab' || !container || container.hidden) return;
      const focusable = [...container.querySelectorAll('a,button,input,select,[tabindex]:not([tabindex="-1"])')].filter((item) => !item.disabled);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    const closeSearch = () => { if (!search) return; search.hidden = true; syncScrollLock(); searchOpener?.focus(); };
    const closeMenu = () => { if (!menu || !toggle) return; menu.hidden = true; menu.setAttribute('aria-hidden', 'true'); toggle.setAttribute('aria-expanded', 'false'); syncScrollLock(); toggle.focus(); };
    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const opening = menu.hidden;
        if (opening) positionMenu();
        menu.hidden = !opening;
        menu.setAttribute('aria-hidden', String(!opening));
        toggle.setAttribute('aria-expanded', String(opening));
        syncScrollLock();
        if (opening) focusFirst(menu);
      });
      window.addEventListener('resize', () => { if (!menu.hidden) positionMenu(); });
      menu.querySelectorAll('a,[data-menu-close]').forEach((item) => item.addEventListener('click', (event) => { if (item.matches('[data-menu-close]')) event.preventDefault(); closeMenu(); }));
    }
    document.querySelectorAll('[data-search-open]').forEach((button) => button.addEventListener('click', () => {
      if (!search) return;
      searchOpener = button;
      search.hidden = false;
      syncScrollLock();
      focusFirst(search);
    }));
    search?.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (event) => {
      if (search && !search.hidden) { trapFocus(event, search); if (event.key === 'Escape') closeSearch(); return; }
      if (menu && !menu.hidden) { trapFocus(event, menu); if (event.key === 'Escape') closeMenu(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => { document.querySelectorAll('[data-yoria-hero]').forEach((hero) => { const slides = [...hero.querySelectorAll('[data-hero-slide]')]; const dots = [...hero.querySelectorAll('[data-hero-dot]')]; const count = hero.querySelector('[data-hero-count]'); if (slides.length < 2) return; let index = 0; let timer; const set = (next) => { index = (next + slides.length) % slides.length; slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index)); dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index)); if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`; }; const play = () => { clearInterval(timer); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => set(index + 1), 6000); }; dots.forEach((dot, i) => dot.addEventListener('click', () => { set(i); play(); })); hero.addEventListener('mouseenter', () => clearInterval(timer)); hero.addEventListener('mouseleave', play); hero.addEventListener('touchstart', () => clearInterval(timer), { passive: true }); hero.addEventListener('touchend', play, { passive: true }); play(); }); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => { document.querySelectorAll('[data-cart-quantity]').forEach((control) => { const input = control.querySelector('[data-quantity-input]'); const form = input?.closest('form'); const updateButton = form?.querySelector('[data-cart-update]'); if (!input || !form || !updateButton) return; let timer; const submit = () => { clearTimeout(timer); timer = setTimeout(() => form.requestSubmit(updateButton), 350); }; const change = (amount) => { input.value = Math.max(0, Number(input.value || 0) + amount); submit(); }; control.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => change(-1)); control.querySelector('[data-quantity-increase]')?.addEventListener('click', () => change(1)); input.addEventListener('change', submit); control.parentElement.querySelector('[data-cart-remove]')?.addEventListener('click', () => { input.value = 0; form.requestSubmit(updateButton); }); }); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-collection-section]').forEach((section) => {
      const params = new URLSearchParams(window.location.search);
      const priceMin = params.get('filter.v.price.gte') || '';
      const priceMax = params.get('filter.v.price.lte') || '';
      section.querySelectorAll('[data-price-min]').forEach((link) => {
        if (link.dataset.priceMin === priceMin && link.dataset.priceMax === priceMax) link.setAttribute('aria-current', 'true');
      });

      const toggle = section.querySelector('[data-filter-toggle]');
      if (!toggle) return;
      const panel = section.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      if (!panel) return;
      const close = () => {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        toggle.focus();
      };
      toggle.addEventListener('click', () => {
        const open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
        if (open) panel.querySelector('[data-filter-close]')?.focus();
      });
      panel.querySelector('[data-filter-close]')?.addEventListener('click', close);
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && panel.classList.contains('is-open')) close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-yoria-product]');
    roots.forEach((root) => {
      const mediaItems = root.querySelectorAll('[data-product-media]');
      const thumbs = root.querySelectorAll('[data-product-thumb]');
      const activateMedia = (index) => {
        mediaItems.forEach((media) => {
          const isActive = media.getAttribute('data-product-media') === index;
          media.hidden = !isActive;
          if (!isActive) media.querySelector('video')?.pause();
        });
        thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.getAttribute('data-product-thumb') === index));
      };
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          activateMedia(thumb.getAttribute('data-product-thumb'));
        });
      });

      const labels = root.querySelector('[data-product-labels]');
      const variantInputs = root.querySelectorAll('[data-product-variant-input]');
      if (variantInputs.length) {
        const updateVariant = () => {
          const option = Array.from(variantInputs).find((input) => input.checked);
          if (!option) return;
          const available = option.dataset.available === 'true';
          const inventoryQuantity = Number.parseInt(option.dataset.inventoryQuantity || '0', 10);
          const inStock = !option.dataset.inventoryManagement || inventoryQuantity > 0;
          const hasShippingExpectation = Boolean(labels?.dataset.shippingExpectation?.trim());
          const inventoryState = inStock ? 'in-stock' : hasShippingExpectation ? 'preorder' : 'sold-out';
          const inventoryHeading = inStock
            ? labels?.dataset.inStockLabel
            : hasShippingExpectation
              ? labels?.dataset.preorderLabel
              : labels?.dataset.outOfStockLabel;
          const inventoryDetail = inStock
            ? labels?.dataset.shippingSpeedLabel
            : hasShippingExpectation
              ? labels?.dataset.shippingExpectation
              : '';
          const variantMedia = option.dataset.mediaId
            ? root.querySelector(`[data-product-media-id="${CSS.escape(option.dataset.mediaId)}"][data-product-media]`)
            : null;
          if (variantMedia) activateMedia(variantMedia.getAttribute('data-product-media'));
          const priceMarkup = option.dataset.comparePrice && option.dataset.comparePrice !== option.dataset.price
            ? `<span class="yoria-price__sale">${option.dataset.price}</span><s class="yoria-price__compare">${option.dataset.comparePrice}</s>`
            : `<span>${option.dataset.price}</span>`;
          root.querySelectorAll('.yoria-price').forEach((price) => { price.innerHTML = priceMarkup; });
          root.querySelectorAll('[data-product-submit], [data-product-sticky-submit]').forEach((button) => {
            button.disabled = !available;
            button.textContent = available ? labels?.dataset.addLabel : labels?.dataset.soldOutLabel;
          });
          const inventoryStatus = root.querySelector('[data-product-inventory-status]');
          if (inventoryStatus) {
            inventoryStatus.classList.remove('is-in-stock', 'is-preorder', 'is-sold-out');
            inventoryStatus.classList.add(`is-${inventoryState}`);
            const heading = inventoryStatus.querySelector('[data-product-inventory-heading]');
            const detail = inventoryStatus.querySelector('[data-product-inventory-detail]');
            const separator = inventoryStatus.querySelector('[data-product-inventory-separator]');
            if (heading) heading.textContent = inventoryHeading;
            if (detail) {
              detail.textContent = inventoryDetail;
              detail.hidden = !inventoryDetail;
            }
            if (separator) separator.hidden = !inventoryDetail;
          }
          const stickyStock = root.querySelector('[data-product-sticky-stock]');
          if (stickyStock) stickyStock.textContent = inventoryHeading;
          const payment = root.querySelector('[data-product-payment]');
          if (payment) payment.hidden = !available;
        };
        variantInputs.forEach((input) => input.addEventListener('change', updateVariant));
        updateVariant();
      }

      const sticky = root.querySelector('[data-product-sticky]');
      if (!sticky) return;
      const onScroll = () => { sticky.hidden = window.scrollY < 520; };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
